import * as Yup from 'yup';

import { AlertEnum, ButtonTypeEnum } from '../../enums';
import { Button, DefaultCard, NumberField, TextField } from '../../components';
import { Form, Formik } from 'formik';
import { useAlert, useAuthAxios, useErrorHandler } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { FunctionComponent } from 'react';
import { GrupoEleitoresFormType } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const grupoEleitoresSchema = (t: Function) =>
  Yup.object().shape({
    denominacao: Yup.string().required(t('validacao.campo_obrigatorio')),
    peso: Yup.number()
      .required(t('validacao.campo_obrigatorio'))
      .min(0.01, t('validacao.peso_invalido'))
      .max(1, t('validacao.peso_invalido')),
    prioridade: Yup.number().required(t('validacao.campo_obrigatorio')),
  });

const initialValues = {
  denominacao: '',
  peso: '1',
  prioridade: '',
};

const GrupoEleitoresForm: FunctionComponent<GrupoEleitoresFormType> = ({ idEleicao, grupoEleitores }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const axios = useAuthAxios();
  const errorHandler = useErrorHandler();
  const { createAlert } = useAlert();
  const isAlteracao = grupoEleitores?.id;

  return (
    <Formik
      initialValues={{ ...initialValues, ...grupoEleitores }}
      validationSchema={grupoEleitoresSchema(t)}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          axios(
            isAlteracao
              ? ApiHelper.getUrl.apiSCE.grupoEleitores(idEleicao, grupoEleitores.id)
              : ApiHelper.getUrl.apiSCE.gruposEleitores(idEleicao),
            {
              data: values,
              method: isAlteracao ? 'PUT' : 'POST',
            },
          )
            .then((response) => {
              navigate(`/eleicoes/${idEleicao}/grupos-eleitores/alterar`);
              createAlert(t(`sucesso.${isAlteracao ? 'alterar' : 'cadastrar'}_grupo_eleitores`), AlertEnum.SUCCESS);
            })
            .catch((error) => errorHandler(error, t(`erro.${isAlteracao ? 'alterar' : 'cadastrar'}_grupo_eleitores`)))
            .finally(() => setSubmitting(false));
        }, 400);
      }}
    >
      {(props) => (
        <Form>
          <DefaultCard
            cardTitle={t('label.dados_grupo_eleitores')}
            footer={
              <div className="d-flex justify-content-center gap-5">
                <Button
                  title={t('label.cancelar')}
                  onClick={() => navigate(`/eleicoes/${idEleicao}/grupos-eleitores/alterar`)}
                  disabled={props.isSubmitting || props.isValidating}
                  outline
                />
                <Button
                  title={t(`label.${isAlteracao ? 'alterar' : 'cadastrar'}`)}
                  type={ButtonTypeEnum.SUBMIT}
                  disabled={props.isSubmitting || props.isValidating}
                />
              </div>
            }
          >
            <TextField label={t('label.denominacao')} name="denominacao" formikProps={props} required />
            <div className="row mt-2">
              <div className="col-md-6">
                <NumberField label={t('label.prioridade')} name="prioridade" formikProps={props} required />
              </div>
              <div className="col-md-6">
                <NumberField label={t('label.peso')} name="peso" formikProps={props} maxLength={4} required />
              </div>
            </div>
          </DefaultCard>
        </Form>
      )}
    </Formik>
  );
};

export default GrupoEleitoresForm;
